import memoizeOne from 'memoize-one';
import { globalColumnDefinition } from '../../../common/Grid/GridColumn';
import isEmpty from 'lodash/isEmpty';
import { getCounterpartyId } from '../../../services/authService';

export const getColumns = memoizeOne((isWritePermission, setFormData) => {
  return [
    Object.assign({ headerName: 'Code', field: 'code' }),
    globalColumnDefinition.shortName,
    Object.assign({}, globalColumnDefinition.longName, {
      onCellClicked: (params) => {
        if (isWritePermission) {
          setFormData(params.data);
        }
      },
      cellClass: [isWritePermission ? 'cursor-pointer text-link' : ''],
    }),
  ];
}, isEmpty);

export const defaultCounterpartyData = () => {
  return {
    code: '',
    shortName: '',
    longName: '',
    client: '',
    counterPartyId: '',
    selectedClientIds: [],
    isActive: false,
  };
};

export const validateFormInput = (data: any) => {
  return data?.longName && data?.shortName && data?.code;
};

export const formatClientOptions = (data: any[]) => {
  if (!data) return [];
  return data.map((i) => ({
    id: i.clientId,
    value: i.clientId,
    label: i.shortCode,
    isActive: i.isActive,
  }));
};

export const createPayload = (data: any, mode: string) => {
  const { selectedClientIds, tenantId, longName, shortName, code, counterPartyId } = data;
  const payload = {
    clientIds: selectedClientIds,
    tenantId: tenantId || getCounterpartyId(),
    longName,
    shortName,
    code,
  };
  if (mode === 'EDIT') {
    payload['counterPartyId'] = counterPartyId;
  }
  return payload;
};

export const modifySelectedCounterpartyResponse = (data: any) => {
  data['selectedClientIds'] = data?.clients?.map((i) => i.clientId);
  return data;
};
